import { IProduct } from './models/product.interface';

export interface ProductResp {
  // tslint:disable-next-line:no-any
  links: any;
  products: IProduct[];
  count: number;
  totalCount: number;
}
